import {RedirectToUrl} from "../RedirectToUrl";
import makeUserSearchUrlForStaticFilters, {TrovitUserSearchUrlParams} from "../urlGenerator";

export interface UserSearch {
    execute(params: TrovitUserSearchUrlParams): void;
}

export class RedirectToUserSearch implements UserSearch {
    redirectToUrl: RedirectToUrl

    constructor(
        redirectToUrl: RedirectToUrl,
    ) {
        this.redirectToUrl = redirectToUrl;
    }

    execute(params: TrovitUserSearchUrlParams): void {
        if (params.what === "") {
            return;
        }

        this.redirectToUrl.goTo(
            makeUserSearchUrlForStaticFilters(params),
        );
    }
}